import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDrawer,
    {
      attrs: {
        value: _vm.value,
        title: _setup.placeFilterLabel,
        width: 376,
        "is-back": "",
        "data-qa": "analyses_lpu_cards_place_drawer",
      },
      on: {
        input: function ($event) {
          return _setup.emit("input", false)
        },
        back: function ($event) {
          return _setup.emit("back")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _setup.isVisibleSearch
                ? _c(_setup.CoreSearchField, {
                    staticClass: "mt-2",
                    attrs: {
                      autofocus: "",
                      maxlength: "150",
                      placeholder: _setup.searchPlaceholder,
                    },
                    on: { "click:clear": _setup.handleClickClear },
                    model: {
                      value: _setup.searchQuery,
                      callback: function ($$v) {
                        _setup.searchQuery =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "searchQuery",
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "append-header",
          fn: function () {
            return [
              !_setup.isDefaultPlace
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-auto",
                      attrs: {
                        color: "primary",
                        small: "",
                        text: "",
                        "data-qa": "analyses_lpu_cards_place_reset_button",
                      },
                      on: { click: _setup.resetPlace },
                    },
                    [_vm._v("\n      Сбросить\n    ")]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "analyses-lpu-place-drawer__footer pa-2 elevation-8",
                },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        block: "",
                        depressed: "",
                        color: "primary",
                        "data-qa": "analyses_lpu_cards_place_apply_button",
                        disabled: !_setup.hasUnsavedPlace,
                      },
                      on: { click: _setup.applyPlace },
                    },
                    [_vm._v("\n        Применить\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _setup.isError
        ? _c(_setup.DrawerError, { staticClass: "py-9" })
        : _setup.isLoading
        ? _c(_setup.DrawerSkeleton, { staticClass: "px-2" })
        : _c(_setup.CoreSelectionList, {
            ref: "selectionListRef",
            staticClass: "py-2",
            attrs: {
              "list-data-qa": "analyses_lpu_cards_place_list",
              "list-item-data-qa": "analyses_lpu_cards_place_list_item",
              items: _setup.places,
              value: _setup.draftPlace || _setup.defaultPlace,
              "search-input": _setup.searchQuery,
              "end-icon": "check",
            },
            on: { input: _setup.onPlaceClick },
            scopedSlots: _vm._u([
              {
                key: "empty",
                fn: function () {
                  return [_c(_setup.DrawerNotFound, { staticClass: "py-3" })]
                },
                proxy: true,
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }